import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ViewedStore = {
  articles: string[];
  _hasHydrated: boolean;
  addArticle: (id: string) => void;
  removeArticle: (id: string) => void;
};

export const useViewed = create<ViewedStore>()(
  persist(
    (set) => ({
      articles: [],
      _hasHydrated: false,

      addArticle: (article) => {
        set((state) => ({
          articles: state.articles.find((item) => item === article)
            ? state.articles
            : [...state.articles, article],
        }));
      },

      removeArticle: (id) => {
        set((state) => ({
          articles: state.articles.filter((i) => i !== id),
        }));
      },
    }),
    {
      name: 'viewed',
    }
  )
);

export const useIsViewed = (id: string) => !!useViewed((state) => state.articles).includes(id);
